module.exports = __webpack_public_path__ + "static/media/schools-mob.a59a0869.jpg";